import {
  Users,
  TrendingUp,
  MapPin,
  Clock,
  Check,
  UserCheck,
} from "lucide-react";

// ─── Helper Function to Generate Stats Data ───────────────────────────────
// Generates the stats array for the SharedStatsGrid component
// Parameters:
//   - t: translations object (language-specific labels)
//   - language: current language ('ar' or 'en')
//   - employees: array of employee objects
//   - monthlyActions: array of actions filtered for the current month
//   - pendingActionsCount: number of pending actions
//
// Returns: Array of stat objects compatible with SharedStatsGrid

export const generateStatsData = (
  t,
  language,
  employees,
  monthlyActions,
  pendingActionsCount,
  onPendingClick
) => {
  return [
    {
      title: t.totalEmployees || "Total Employees",
      value: employees.length,
      icon: Users,
      iconBackground: "rgb(0, 180, 72)",
      showSymbol: true,
      valueAlign: 50,
      showSubtitle: false,
      wrapTitle: true,
      subtitle: language === "ar" ? "الموظفين النشطين" : "Active staff",
    },
    {
      title: t.promotionsThisMonth || "Promotions",
      value: monthlyActions.filter((a) => a.actionType === "promote").length,
      icon: TrendingUp,
      iconBackground: "rgb(180, 57, 0)",
      showSymbol: true,
      valueAlign: 50,
      showSubtitle: false,
      wrapTitle: true,
      subtitle: language === "ar" ? "هذا الشهر" : "This month",
    },
    {
      title: t.transfersThisMonth || "Transfers",
      value: monthlyActions.filter((a) => a.actionType === "transfer").length,
      icon: MapPin,
      iconBackground: "rgb(180, 0, 72)",
      showSymbol: true,
      valueAlign: 50,
      showSubtitle: false,
      wrapTitle: true,
      subtitle: language === "ar" ? "هذا الشهر" : "This month",
    },
    {
      key: "pending",
      title: t.pendingApprovals || "Pending Approvals",
      value: pendingActionsCount,
      icon: Clock,
      iconBackground: "rgb(180, 100, 0)",
      showSymbol: true,
      valueAlign: 50,
      showSubtitle: false,
      wrapTitle: true,
      subtitle: language === "ar" ? "بانتظار المراجعة" : "Awaiting review",
    },
    {
      title: t.completedActions || "Completed Actions",
      value: monthlyActions.length,
      icon: Check,
      iconBackground: "rgb(0, 120, 180)",
      showSymbol: true,
      valueAlign: 50,
      showSubtitle: false,
      wrapTitle: true,
      subtitle: language === "ar" ? "هذا الشهر" : "This month",
    },
  ];
};

// ─── Default/Empty Stats Data ─────────────────────────────────────────────
// Used as fallback when data fetch fails or during initial load

export const getDefaultStatsData = (t, language) => [
  {
    title: t.totalEmployees || "Total Employees",
    value: 0,
    icon: Users,
    iconBackground: "rgb(0, 180, 72)",
    showSymbol: true,
    valueAlign: 50,
    showSubtitle: false,
    wrapTitle: true,
    subtitle: language === "ar" ? "الموظفين النشطين" : "Active staff",
  },
  {
    title: t.promotionsThisMonth || "Promotions",
    value: 0,
    icon: TrendingUp,
    iconBackground: "rgb(180, 57, 0)",
    showSymbol: true,
    valueAlign: 50,
    showSubtitle: false,
    wrapTitle: true,
    subtitle: language === "ar" ? "هذا الشهر" : "This month",
  },
  {
    title: t.transfersThisMonth || "Transfers",
    value: 0,
    icon: MapPin,
    iconBackground: "rgb(180, 0, 72)",
    showSymbol: true,
    valueAlign: 50,
    showSubtitle: false,
    wrapTitle: true,
    subtitle: language === "ar" ? "هذا الشهر" : "This month",
  },
  {
    key: "pending",
    title: t.pendingApprovals || "Pending Approvals",
    value: 0,
    icon: Clock,
    iconBackground: "rgb(180, 100, 0)",
    showSymbol: true,
    valueAlign: 50,
    showSubtitle: false,
    wrapTitle: true,
    subtitle: language === "ar" ? "بانتظار المراجعة" : "Awaiting review",
  },
  {
    title: t.completedActions || "Completed Actions",
    value: 0,
    icon: Check,
    iconBackground: "rgb(0, 120, 180)",
    showSymbol: true,
    valueAlign: 50,
    showSubtitle: false,
    wrapTitle: true,
    subtitle: language === "ar" ? "هذا الشهر" : "This month",
  },
];
